import { render, staticRenderFns } from "./KumpulBencanaInput.vue?vue&type=template&id=42ccf251&scoped=true"
import script from "./KumpulBencanaInput.vue?vue&type=script&lang=js"
export * from "./KumpulBencanaInput.vue?vue&type=script&lang=js"
import style0 from "./KumpulBencanaInput.vue?vue&type=style&index=0&id=42ccf251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ccf251",
  null
  
)

export default component.exports